import { Button, ButtonGroup } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../localization'
import { useStyles } from './styles/index.styles'

type RangeType = {
  label: string
  value: 'THREE_MONTH' | 'MONTH' | 'YEAR'
}

interface ViewSelectorProps {
  options: RangeType[]
  selectedIndex: number
  onSelectionChange: (index: number) => void
}

const ViewSelector: React.FC<ViewSelectorProps> = ({
  options,
  selectedIndex,
  onSelectionChange
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ButtonGroup className={classes.buttonGroup}>
        {options.map((option, index) => (
          <Button
            key={option.value}
            onClick={() => onSelectionChange(index)}
            className={`${classes.button} ${
              index === selectedIndex ? 'selected' : ''
            }`}>
            {getTranslate(option.label)}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  )
}

export default ViewSelector
